/**
 * Default SEO configuration for the website
 * This file contains default SEO settings that can be used across the site
 */

const defaultSEO = {
  // Site defaults
  siteName: 'Teem Wildlife Wonders',
  siteUrl: process.env.REACT_APP_SITE_URL || 'https://teemwildlifewonders.com',
  
  // Default meta tags
  defaultTitle: 'Premium Safari Tours & Wildlife Experiences',
  defaultDescription: 'Experience unforgettable adventures with our premium safari tours and wildlife experiences across breathtaking destinations in Africa.',
  defaultKeywords: [
    'safari tours', 
    'wildlife experiences', 
    'African safari', 
    'tour packages', 
    'wildlife adventures', 
    'luxury safari',
    'Kenya tours',
    'Tanzania safari',
    'wildlife photography',
    'safari vacation'
  ],
  
  // Default Open Graph image
  defaultOgImage: '/images/og-default.jpg',
  
  // Social media profiles
  social: {
    twitter: '@teemwildlife',
    facebook: 'https://facebook.com/teemwildlifewonders',
    instagram: 'https://instagram.com/teemwildlifewonders'
  },
  
  // Organization schema for JSON-LD
  organizationSchema: {
    '@context': 'https://schema.org',
    '@type': 'TravelAgency',
    name: 'Teem Wildlife Wonders',
    url: 'https://teemwildlifewonders.com',
    logo: 'https://teemwildlifewonders.com/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+254-XXX-XXX-XXX',
      contactType: 'customer service',
      availableLanguage: ['English', 'Swahili']
    },
    sameAs: [
      'https://facebook.com/teemwildlifewonders',
      'https://instagram.com/teemwildlifewonders',
      'https://twitter.com/teemwildlife'
    ]
  }
};

export default defaultSEO;
